import type { IMediumDto_Props } from './MediumDto.if';
import type { IModelSource } from '../interface/db';
import type ILanguageDto from './LanguageDto.if';
import type ISiteDto from './SiteDto.if';

export interface IMediumDto_Linkables {
    site: (db: IModelSource) => Promise<ISiteDto>;
    languages: (db: IModelSource) => Promise<ILanguageDto[]>;
}

function _site(this: Partial<IMediumDto_Props>, db: IModelSource): Promise<ISiteDto> {
    return this.siteId
        ? db.get('ISiteDto', this.siteId)
        : Promise.reject('Missing field medium.siteId');
}

function _languages(this: Partial<IMediumDto_Props>, db: IModelSource): Promise<ILanguageDto[]> {
    if (!this.id) {
        return Promise.reject('Missing field medium.id');
    }
    const self = this;

    return new Promise(async function (resolve, reject) {
        try {
            /* this is inefficient, but works. Fetch all translations, filter until the mediumId matches this & then fetch the related languages */
            const allSOTs = await db.all('ISiteObjectTranslationDto');
            const matchSOTs = allSOTs.filter(sot => sot.mediumId === self.id);
            const languageIds = matchSOTs.map(sot => sot.languageId);
            const languages = await Promise.all(languageIds.map(id => db.get('ILanguageDto', id)));

            resolve(languages);
        } catch (error) {
            reject(`Error occurred fetching MediumDto.languages: ${error}`);
        }
    });
}

/** 
 * @description all custom properties for
   MediumDto & methods to link against other entities
*/
function linkables(model: Partial<IMediumDto_Props>): IMediumDto_Linkables {
    return {
        site: _site,
        languages: _languages,
    };
}

export default linkables;
